// It is important to choose an enum key that is in the native language (with proper capitlization as well)
// We use this key in a few places (display current language name, language select radio buttons)
export enum LanguageCode {
  Svenska = 'sv',
  English = 'en',
  Latviešu = 'lv',
  Portuguese = 'pt',
}
